module.exports = "/_next/static/images/chat-monotone-dce2b89614df5804262e731eae4dbc8d.svg";